import Img1 from "../assets/images/blog/post-1.jpeg";
import Img2 from "../assets/images/blog/post-2.jpeg";
import Img3 from "../assets/images/blog/post-3.jpeg";
import Img4 from "../assets/images/blog/post-4.jpeg";
import Img5 from "../assets/images/blog/post-5.jpeg";
import Img6 from "../assets/images/blog/post-6.jpeg";
import Img7 from "../assets/images/blog/post-7.jpeg";
import Img8 from "../assets/images/blog/post-8.jpeg";
import Img9 from "../assets/images/blog/post-9.jpeg";
import Img10 from "../assets/images/blog/post-10.jpeg";

export const AllBlogPosts = [
  {
    BlogImg: Img1,
    BlogName: "Pizza Crust Types: Self-Rising And Par-Baked",
    BlogSnippet:
      "Maecenas interdum erat justo, eget posuere mi vehicula et. Fusce ut elit ex...",
    BlogDate: "July 12, 2021",
    BlogAuthor: "Daniel Wilson",
    id: "",
  },

  {
    BlogImg: Img2,
    BlogName:
      "Thick Or Thin: Different Styles Of Pizza Crust For 8 Classic Pies",
    BlogSnippet:
      "Aenean convallis tempor vehicula. Nunc pellentesque porta libero...",
    BlogDate: "July 1, 2021",
    BlogAuthor: "Anna Anderson",
    id: "",
  },
  {
    BlogImg: Img3,
    BlogName: "What To Do With Leftover Pizza Dough",
    BlogSnippet:
      "Nullam sit amet semper est. Proin laoreet diam quis tortor malesuada, eget mattis orci vulputate...",
    BlogDate: "June 27, 2021",
    BlogAuthor: "Catherine Wright",
    id: "",
  },
  {
    BlogImg: Img4,
    BlogName: "Dill Pickle Pizza Recipe",
    BlogSnippet:
      "In sed suscipit massa. Aenean ultricies massa eget ligula sollicitudin semper....",
    BlogDate: "June 12, 2021",
    BlogAuthor: "Nina Kowalski",
    id: "",
  },
  {
    BlogImg: Img5,
    BlogName: "5 Accessories To Take Your Pizza Party To The Next Level!",
    BlogSnippet:
      "Aenean maximus magna et nisl vehicula dapibus. Aenean eget mattis dui...",
    BlogDate: "May 10, 2021",
    BlogAuthor: "Cara Nelson",
    id: "",
  },
  {
    BlogImg: Img6,
    BlogName: "The Best Vegan Cheese and Meat For Pizza",
    BlogSnippet:
      "Mauris quis est vel arcu malesuada malesuada a ac nisi. Quisque in fringilla diam. Proin a facilisis justo...",
    BlogDate: "May 3, 2021",
    BlogAuthor: "Tom Wilson",
    id: "",
  },
  {
    BlogImg: Img7,
    BlogName: "National BBQ (Pizza) Month! Gear For Your Grill",
    BlogSnippet:
      "Donec efficitur tempor luctus. In sed suscipit massa. Aenean ultricies massa eget ligula sollicitudin semper...",
    BlogDate: "April 11, 2021",
    BlogAuthor: "Kerry Smith",
    id: "",
  },
  {
    BlogImg: Img8,
    BlogName: "The Biggest Mistakes When Making Pizza",
    BlogSnippet:
      "Proin pretium, tortor id laoreet ornare, orci sapien vulputate lorem, ac maximus sapien arcu nec metus...",
    BlogDate: "April 2, 2021",
    BlogAuthor: "Kira Wilson",
    id: "",
  },
  {
    BlogImg: Img9,
    BlogName: "What is the perfect mozzarella for your cheese pizza?",
    BlogSnippet:
      "Mauris non luctus nibh, eget convallis quam. Etiam eleifend malesuada ipsum ut interdum...",
    BlogDate: "March 18, 2021",
    BlogAuthor: "George Denson",
    id: "",
  },
  {
    BlogImg: Img10,
    BlogName: "Breakfast Pizza Recipe",
    BlogSnippet:
      "Quisque sit amet molestie erat. Quisque sed eros interdum, faucibus magna in, aliquet enim...",
    BlogDate: "March 7, 2021",
    BlogAuthor: "Alex Lee",
    id: "",
  },
  {
    BlogImg: Img1,
    BlogName: "Pizza Crust Types: Self-Rising And Par-Baked",
    BlogSnippet:
      "Maecenas interdum erat justo, eget posuere mi vehicula et. Fusce ut elit ex...",
    BlogDate: "July 12, 2021",
    BlogAuthor: "Daniel Wilson",
    id: "",
  },

  {
    BlogImg: Img2,
    BlogName:
      "Thick Or Thin: Different Styles Of Pizza Crust For 8 Classic Pies",
    BlogSnippet:
      "Aenean convallis tempor vehicula. Nunc pellentesque porta libero...",
    BlogDate: "July 1, 2021",
    BlogAuthor: "Anna Anderson",
    id: "",
  },
  {
    BlogImg: Img3,
    BlogName: "What To Do With Leftover Pizza Dough",
    BlogSnippet:
      "Nullam sit amet semper est. Proin laoreet diam quis tortor malesuada, eget mattis orci vulputate...",
    BlogDate: "June 27, 2021",
    BlogAuthor: "Catherine Wright",
    id: "",
  },
  {
    BlogImg: Img4,
    BlogName: "Dill Pickle Pizza Recipe",
    BlogSnippet:
      "In sed suscipit massa. Aenean ultricies massa eget ligula sollicitudin semper....",
    BlogDate: "June 12, 2021",
    BlogAuthor: "Nina Kowalski",
    id: "",
  },
  {
    BlogImg: Img5,
    BlogName: "5 Accessories To Take Your Pizza Party To The Next Level!",
    BlogSnippet:
      "Aenean maximus magna et nisl vehicula dapibus. Aenean eget mattis dui...",
    BlogDate: "May 10, 2021",
    BlogAuthor: "Cara Nelson",
    id: "",
  },
  {
    BlogImg: Img6,
    BlogName: "The Best Vegan Cheese and Meat For Pizza",
    BlogSnippet:
      "Mauris quis est vel arcu malesuada malesuada a ac nisi. Quisque in fringilla diam. Proin a facilisis justo...",
    BlogDate: "May 3, 2021",
    BlogAuthor: "Tom Wilson",
    id: "",
  },
  {
    BlogImg: Img7,
    BlogName: "National BBQ (Pizza) Month! Gear For Your Grill",
    BlogSnippet:
      "Donec efficitur tempor luctus. In sed suscipit massa. Aenean ultricies massa eget ligula sollicitudin semper...",
    BlogDate: "April 11, 2021",
    BlogAuthor: "Kerry Smith",
    id: "",
  },
  {
    BlogImg: Img8,
    BlogName: "The Biggest Mistakes When Making Pizza",
    BlogSnippet:
      "Proin pretium, tortor id laoreet ornare, orci sapien vulputate lorem, ac maximus sapien arcu nec metus...",
    BlogDate: "April 2, 2021",
    BlogAuthor: "Kira Wilson",
    id: "",
  },
  {
    BlogImg: Img9,
    BlogName: "What is the perfect mozzarella for your cheese pizza?",
    BlogSnippet:
      "Mauris non luctus nibh, eget convallis quam. Etiam eleifend malesuada ipsum ut interdum...",
    BlogDate: "March 18, 2021",
    BlogAuthor: "George Denson",
    id: "",
  },
  {
    BlogImg: Img10,
    BlogName: "Breakfast Pizza Recipe",
    BlogSnippet:
      "Quisque sit amet molestie erat. Quisque sed eros interdum, faucibus magna in, aliquet enim...",
    BlogDate: "March 7, 2021",
    BlogAuthor: "Alex Lee",
    id: "",
  },
  {
    BlogImg: Img1,
    BlogName: "Pizza Crust Types: Self-Rising And Par-Baked",
    BlogSnippet:
      "Maecenas interdum erat justo, eget posuere mi vehicula et. Fusce ut elit ex...",
    BlogDate: "July 12, 2021",
    BlogAuthor: "Daniel Wilson",
    id: "",
  },

  {
    BlogImg: Img2,
    BlogName:
      "Thick Or Thin: Different Styles Of Pizza Crust For 8 Classic Pies",
    BlogSnippet:
      "Aenean convallis tempor vehicula. Nunc pellentesque porta libero...",
    BlogDate: "July 1, 2021",
    BlogAuthor: "Anna Anderson",
    id: "",
  },
  {
    BlogImg: Img3,
    BlogName: "What To Do With Leftover Pizza Dough",
    BlogSnippet:
      "Nullam sit amet semper est. Proin laoreet diam quis tortor malesuada, eget mattis orci vulputate...",
    BlogDate: "June 27, 2021",
    BlogAuthor: "Catherine Wright",
    id: "",
  },
  {
    BlogImg: Img4,
    BlogName: "Dill Pickle Pizza Recipe",
    BlogSnippet:
      "In sed suscipit massa. Aenean ultricies massa eget ligula sollicitudin semper....",
    BlogDate: "June 12, 2021",
    BlogAuthor: "Nina Kowalski",
    id: "",
  },
  {
    BlogImg: Img5,
    BlogName: "5 Accessories To Take Your Pizza Party To The Next Level!",
    BlogSnippet:
      "Aenean maximus magna et nisl vehicula dapibus. Aenean eget mattis dui...",
    BlogDate: "May 10, 2021",
    BlogAuthor: "Cara Nelson",
    id: "",
  },
  {
    BlogImg: Img6,
    BlogName: "The Best Vegan Cheese and Meat For Pizza",
    BlogSnippet:
      "Mauris quis est vel arcu malesuada malesuada a ac nisi. Quisque in fringilla diam. Proin a facilisis justo...",
    BlogDate: "May 3, 2021",
    BlogAuthor: "Tom Wilson",
    id: "",
  },
  {
    BlogImg: Img7,
    BlogName: "National BBQ (Pizza) Month! Gear For Your Grill",
    BlogSnippet:
      "Donec efficitur tempor luctus. In sed suscipit massa. Aenean ultricies massa eget ligula sollicitudin semper...",
    BlogDate: "April 11, 2021",
    BlogAuthor: "Kerry Smith",
    id: "",
  },
  {
    BlogImg: Img8,
    BlogName: "The Biggest Mistakes When Making Pizza",
    BlogSnippet:
      "Proin pretium, tortor id laoreet ornare, orci sapien vulputate lorem, ac maximus sapien arcu nec metus...",
    BlogDate: "April 2, 2021",
    BlogAuthor: "Kira Wilson",
    id: "",
  },
  {
    BlogImg: Img9,
    BlogName: "What is the perfect mozzarella for your cheese pizza?",
    BlogSnippet:
      "Mauris non luctus nibh, eget convallis quam. Etiam eleifend malesuada ipsum ut interdum...",
    BlogDate: "March 18, 2021",
    BlogAuthor: "George Denson",
    id: "",
  },
  {
    BlogImg: Img10,
    BlogName: "Breakfast Pizza Recipe",
    BlogSnippet:
      "Quisque sit amet molestie erat. Quisque sed eros interdum, faucibus magna in, aliquet enim...",
    BlogDate: "March 7, 2021",
    BlogAuthor: "Alex Lee",
    id: "",
  },
  {
    BlogImg: Img1,
    BlogName: "Pizza Crust Types: Self-Rising And Par-Baked",
    BlogSnippet:
      "Maecenas interdum erat justo, eget posuere mi vehicula et. Fusce ut elit ex...",
    BlogDate: "July 12, 2021",
    BlogAuthor: "Daniel Wilson",
    id: "",
  },

  {
    BlogImg: Img2,
    BlogName:
      "Thick Or Thin: Different Styles Of Pizza Crust For 8 Classic Pies",
    BlogSnippet:
      "Aenean convallis tempor vehicula. Nunc pellentesque porta libero...",
    BlogDate: "July 1, 2021",
    BlogAuthor: "Anna Anderson",
    id: "",
  },
  {
    BlogImg: Img3,
    BlogName: "What To Do With Leftover Pizza Dough",
    BlogSnippet:
      "Nullam sit amet semper est. Proin laoreet diam quis tortor malesuada, eget mattis orci vulputate...",
    BlogDate: "June 27, 2021",
    BlogAuthor: "Catherine Wright",
    id: "",
  },
  {
    BlogImg: Img4,
    BlogName: "Dill Pickle Pizza Recipe",
    BlogSnippet:
      "In sed suscipit massa. Aenean ultricies massa eget ligula sollicitudin semper....",
    BlogDate: "June 12, 2021",
    BlogAuthor: "Nina Kowalski",
    id: "",
  },
  {
    BlogImg: Img5,
    BlogName: "5 Accessories To Take Your Pizza Party To The Next Level!",
    BlogSnippet:
      "Aenean maximus magna et nisl vehicula dapibus. Aenean eget mattis dui...",
    BlogDate: "May 10, 2021",
    BlogAuthor: "Cara Nelson",
    id: "",
  },
  {
    BlogImg: Img6,
    BlogName: "The Best Vegan Cheese and Meat For Pizza",
    BlogSnippet:
      "Mauris quis est vel arcu malesuada malesuada a ac nisi. Quisque in fringilla diam. Proin a facilisis justo...",
    BlogDate: "May 3, 2021",
    BlogAuthor: "Tom Wilson",
    id: "",
  },
  {
    BlogImg: Img7,
    BlogName: "National BBQ (Pizza) Month! Gear For Your Grill",
    BlogSnippet:
      "Donec efficitur tempor luctus. In sed suscipit massa. Aenean ultricies massa eget ligula sollicitudin semper...",
    BlogDate: "April 11, 2021",
    BlogAuthor: "Kerry Smith",
    id: "",
  },
  {
    BlogImg: Img8,
    BlogName: "The Biggest Mistakes When Making Pizza",
    BlogSnippet:
      "Proin pretium, tortor id laoreet ornare, orci sapien vulputate lorem, ac maximus sapien arcu nec metus...",
    BlogDate: "April 2, 2021",
    BlogAuthor: "Kira Wilson",
    id: "",
  },
  {
    BlogImg: Img9,
    BlogName: "What is the perfect mozzarella for your cheese pizza?",
    BlogSnippet:
      "Mauris non luctus nibh, eget convallis quam. Etiam eleifend malesuada ipsum ut interdum...",
    BlogDate: "March 18, 2021",
    BlogAuthor: "George Denson",
    id: "",
  },
  {
    BlogImg: Img10,
    BlogName: "Breakfast Pizza Recipe",
    BlogSnippet:
      "Quisque sit amet molestie erat. Quisque sed eros interdum, faucibus magna in, aliquet enim...",
    BlogDate: "March 7, 2021",
    BlogAuthor: "Alex Lee",
    id: "",
  },
  {
    BlogImg: Img1,
    BlogName: "Pizza Crust Types: Self-Rising And Par-Baked",
    BlogSnippet:
      "Maecenas interdum erat justo, eget posuere mi vehicula et. Fusce ut elit ex...",
    BlogDate: "July 12, 2021",
    BlogAuthor: "Daniel Wilson",
    id: "",
  },

  {
    BlogImg: Img2,
    BlogName:
      "Thick Or Thin: Different Styles Of Pizza Crust For 8 Classic Pies",
    BlogSnippet:
      "Aenean convallis tempor vehicula. Nunc pellentesque porta libero...",
    BlogDate: "July 1, 2021",
    BlogAuthor: "Anna Anderson",
    id: "",
  },
  {
    BlogImg: Img3,
    BlogName: "What To Do With Leftover Pizza Dough",
    BlogSnippet:
      "Nullam sit amet semper est. Proin laoreet diam quis tortor malesuada, eget mattis orci vulputate...",
    BlogDate: "June 27, 2021",
    BlogAuthor: "Catherine Wright",
    id: "",
  },
  {
    BlogImg: Img4,
    BlogName: "Dill Pickle Pizza Recipe",
    BlogSnippet:
      "In sed suscipit massa. Aenean ultricies massa eget ligula sollicitudin semper....",
    BlogDate: "June 12, 2021",
    BlogAuthor: "Nina Kowalski",
    id: "",
  },
  {
    BlogImg: Img5,
    BlogName: "5 Accessories To Take Your Pizza Party To The Next Level!",
    BlogSnippet:
      "Aenean maximus magna et nisl vehicula dapibus. Aenean eget mattis dui...",
    BlogDate: "May 10, 2021",
    BlogAuthor: "Cara Nelson",
    id: "",
  },
  {
    BlogImg: Img6,
    BlogName: "The Best Vegan Cheese and Meat For Pizza",
    BlogSnippet:
      "Mauris quis est vel arcu malesuada malesuada a ac nisi. Quisque in fringilla diam. Proin a facilisis justo...",
    BlogDate: "May 3, 2021",
    BlogAuthor: "Tom Wilson",
    id: "",
  },
  {
    BlogImg: Img7,
    BlogName: "National BBQ (Pizza) Month! Gear For Your Grill",
    BlogSnippet:
      "Donec efficitur tempor luctus. In sed suscipit massa. Aenean ultricies massa eget ligula sollicitudin semper...",
    BlogDate: "April 11, 2021",
    BlogAuthor: "Kerry Smith",
    id: "",
  },
  {
    BlogImg: Img8,
    BlogName: "The Biggest Mistakes When Making Pizza",
    BlogSnippet:
      "Proin pretium, tortor id laoreet ornare, orci sapien vulputate lorem, ac maximus sapien arcu nec metus...",
    BlogDate: "April 2, 2021",
    BlogAuthor: "Kira Wilson",
    id: "",
  },
  {
    BlogImg: Img9,
    BlogName: "What is the perfect mozzarella for your cheese pizza?",
    BlogSnippet:
      "Mauris non luctus nibh, eget convallis quam. Etiam eleifend malesuada ipsum ut interdum...",
    BlogDate: "March 18, 2021",
    BlogAuthor: "George Denson",
    id: "",
  },
  {
    BlogImg: Img10,
    BlogName: "Breakfast Pizza Recipe",
    BlogSnippet:
      "Quisque sit amet molestie erat. Quisque sed eros interdum, faucibus magna in, aliquet enim...",
    BlogDate: "March 7, 2021",
    BlogAuthor: "Alex Lee",
    id: "",
  },
];


